/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./auth-card-footer.component";
var styles_AuthCardFooterComponent = [];
var RenderType_AuthCardFooterComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AuthCardFooterComponent, data: {} });
export { RenderType_AuthCardFooterComponent as RenderType_AuthCardFooterComponent };
export function View_AuthCardFooterComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "div", [["class", "additional-info"]], null, null, null, null, null)), i0.ɵncd(null, 0)], null, null); }
export function View_AuthCardFooterComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-auth-card-footer", [], null, null, null, View_AuthCardFooterComponent_0, RenderType_AuthCardFooterComponent)), i0.ɵdid(1, 114688, null, 0, i1.AuthCardFooterComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AuthCardFooterComponentNgFactory = i0.ɵccf("app-auth-card-footer", i1.AuthCardFooterComponent, View_AuthCardFooterComponent_Host_0, {}, {}, ["*"]);
export { AuthCardFooterComponentNgFactory as AuthCardFooterComponentNgFactory };
